export default "__VITE_ASSET__f66222e0__"